import { Injectable } from '@angular/core';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';

@Injectable({
  providedIn: 'root',
})
export class UserSessionStorageService {
  private secretKey = 'nxdP5JYR4w';

  constructor() { }

  private encrypt(data: string): string {
    return AES.encrypt(data, this.secretKey).toString();
  }

  private decrypt(data: string): string {
    const bytes = AES.decrypt(data, this.secretKey);
    return bytes.toString(Utf8);
  }

  getItem(key: string) {
    try {
      const encryptedData = localStorage.getItem(key);
      if (encryptedData) {
        return JSON.parse(this.decrypt(encryptedData));
      }
      return null;
    } catch (error: any) {
      console.log(error);
      return null;
    }
  }

  setItem(key: string, value: string | any) {
    try {
      const encryptedValue = this.encrypt(JSON.stringify(value));
      return localStorage.setItem(key, encryptedValue);
    } catch (error) {
      console.log(error);
    }
  }

  removeItem(key: string) {
    try {
      return localStorage.removeItem(key);
    } catch (error) {
      console.log(error);
    }
  }

  clearEntireSession() {
    localStorage.clear();
  }
}
